import React from "react";

export const Footer = () => {
  return (
    <footer>
      <p id="copy">&copy;&nbsp;Sorimachi&nbsp;Co.,Ltd.</p>
    </footer>
  );
};